import * as React from 'react';

/**
 * The RuntimeContext is deprecated and will be removed in the future as it's too generic,
 * we should supply props trough more specific contexts.
 *
 * Please do not add this component in any new components outside this package or extend the current model
 */ const RuntimeContext = React.createContext({});

export { RuntimeContext };
//# sourceMappingURL=runtime-context.js.map
